/*
  ak-blog-places.js
  Behaviour for sections/blog-places-v3.liquid. The section renders everything on the
  server; this file only adds:
  - filters: kids ages (every picked age must fit) and areas (any picked area)
  - picks tabs (tabs style only)
  - in-page links that clear filters when they point at a hidden card
  - birthday cards: Read more, and the WhatsApp link rebuilt on click
  - GA4: view_item_list, select_item, ak_blog_filter, ak_blog_pick, ak_blog_tab,
    ak_blog_details, ak_blog_ask_us, whatsapp_click (birthday card button, ak_source card)
  No URL parameters are written: filters are a view, not a page.
*/
(function () {
  'use strict';

  function tag() {
    var fn = window.AKEmit || window.akEmit || window.gtag;
    if (typeof fn === 'function') { fn.apply(null, arguments); return; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  function ageName(a) { return a === 13 ? '13+' : String(a); }
  function joinAnd(list) {
    return list.length < 2 ? list.join('') : list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }

  function init(root) {
    if (!root || root.__akbp) return;
    root.__akbp = true;

    var LIST_ID = root.dataset.listId || 'blog_places';
    var LIST_NAME = root.dataset.listName || document.title;
    var TOTAL = Number(root.dataset.total) || 0;
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var bar = q('[data-akbp-bar]');
    var list = q('[data-akbp-list]');
    var status = q('[data-akbp-status]');
    var countEl = q('[data-akbp-count]');
    var ageChip = q('[data-akbp-agechip]');
    var ageLabel = q('[data-akbp-agelabel]');
    var ageChev = q('[data-akbp-agechev]');
    var agesBox = q('[data-akbp-ages]');
    var ageSum = q('[data-akbp-agesum]');
    var empty = q('[data-akbp-empty]');
    var emptyHint = q('[data-akbp-emptyhint]');
    var removeBestBtn = q('[data-akbp-removebest]');
    var ageBtns = qa('[data-akbp-age]');
    var areaBtns = qa('[data-akbp-area]');

    var cards = qa('[data-akbp-card]').map(function (el) {
      var mn = el.dataset.min, mx = el.dataset.max;
      return {
        el: el,
        min: mn === '' || mn == null ? null : Number(mn),
        max: mx === '' || mx == null ? null : Number(mx),
        areas: el.dataset.areas ? el.dataset.areas.split('|') : [],
        suits: el.querySelector('[data-akbp-suits]'),
        suitsText: el.querySelector('[data-akbp-suits-text]')
      };
    });

    var state = { ages: [], areas: [] };

    function fitsAges(c, ages) {
      if (c.min === null) return true;
      return ages.every(function (a) { return a >= c.min && (c.max === null || a <= c.max); });
    }
    function matches(c, s) {
      if (!fitsAges(c, s.ages)) return false;
      if (!s.areas.length) return true;
      return s.areas.some(function (a) { return c.areas.indexOf(a) !== -1; });
    }
    function count(s) { return cards.filter(function (c) { return matches(c, s); }).length; }
    function anySel() { return state.ages.length > 0 || state.areas.length > 0; }

    function render() {
      var shown = 0;
      var sorted = state.ages.slice().sort(function (a, b) { return a - b; });
      var names = sorted.map(ageName);
      var suitsTxt = names.length === 1 ? 'Suits age ' + names[0] : 'Suits ages ' + joinAnd(names);

      cards.forEach(function (c) {
        var ok = matches(c, state);
        c.el.hidden = !ok;
        if (ok) shown++;
        if (c.suits) {
          var show = ok && state.ages.length > 0 && c.min !== null;
          c.suits.hidden = !show;
          if (show && c.suitsText) c.suitsText.textContent = suitsTxt;
        }
      });

      areaBtns.forEach(function (b) {
        var a = b.dataset.akbpArea;
        var on = state.areas.indexOf(a) !== -1;
        var n = on ? shown : count({ ages: state.ages, areas: state.areas.concat([a]) });
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-zero', !on && n === 0);
        var nEl = b.querySelector('[data-akbp-n]');
        if (nEl) nEl.textContent = String(n);
      });

      ageBtns.forEach(function (b) {
        var a = Number(b.dataset.akbpAge);
        var on = state.ages.indexOf(a) !== -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var hasAges = state.ages.length > 0;
      /* Birthday cards have no ages filter, and no bar at all when there are no area chips. */
      if (ageChip) {
        ageLabel.textContent = hasAges ? (state.ages.length === 1 ? 'Age ' : 'Ages ') + names.join(', ') : 'Kids ages';
        ageChip.classList.toggle('is-set', hasAges);
        ageSum.textContent = hasAges
          ? shown + (shown === 1 ? ' place suits ' : ' places suit ') + (state.ages.length === 1 ? 'this age' : 'all ' + state.ages.length + ' kids')
          : 'No ages picked yet';
      }

      if (status) {
        status.hidden = !anySel();
        countEl.textContent = 'Showing ' + shown + ' of ' + TOTAL + ' places';
      }

      empty.hidden = shown !== 0;
      if (shown === 0) {
        var best = bestRemoval();
        if (best) {
          emptyHint.textContent = 'Removing ' + best.label + ' brings back ' + best.n + (best.n === 1 ? ' place.' : ' places.');
          removeBestBtn.textContent = 'Remove ' + best.label;
          removeBestBtn.hidden = false;
          removeBestBtn.__best = best;
        } else {
          emptyHint.textContent = '';
          removeBestBtn.hidden = true;
        }
      }
      return shown;
    }

    function bestRemoval() {
      var best = null;
      state.areas.forEach(function (a) {
        var n = count({ ages: state.ages, areas: state.areas.filter(function (x) { return x !== a; }) });
        if (!best || n > best.n) best = { kind: 'area', id: a, n: n, label: a };
      });
      state.ages.forEach(function (a) {
        var n = count({ ages: state.ages.filter(function (x) { return x !== a; }), areas: state.areas });
        if (!best || n > best.n) best = { kind: 'age', id: a, n: n, label: 'age ' + ageName(a) };
      });
      return best;
    }

    /* After a filter change, bring the top of the list back under the bar if the
       visitor had scrolled past it. */
    function keepListInView() {
      if (!list || !bar) return;
      var barH = bar.getBoundingClientRect().height;
      var top = list.getBoundingClientRect().top;
      if (top < barH) {
        window.scrollTo({ top: window.pageYOffset + top - barH - 12, behavior: 'auto' });
      }
    }

    function filterEvent(type, value, on, shown) {
      tag('event', 'ak_blog_filter', {
        item_list_id: LIST_ID,
        filter_type: type,
        filter_value: String(value),
        filter_on: on,
        ak_ages: state.ages.slice().sort(function (a, b) { return a - b; }).join(','),
        ak_areas: state.areas.join(','),
        results_count: shown
      });
    }

    function setAgesOpen(open) {
      agesBox.hidden = !open;
      ageChip.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (ageChev) ageChev.setAttribute('d', open ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6');
    }

    if (ageChip) {
      ageChip.addEventListener('click', function () { setAgesOpen(agesBox.hidden); });
      q('[data-akbp-done]').addEventListener('click', function () {
        setAgesOpen(false);
        keepListInView();
      });
    }

    ageBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var a = Number(b.dataset.akbpAge);
        var i = state.ages.indexOf(a);
        if (i === -1) state.ages.push(a); else state.ages.splice(i, 1);
        var shown = render();
        filterEvent('age', a, i === -1, shown);
      });
    });

    areaBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var a = b.dataset.akbpArea;
        var i = state.areas.indexOf(a);
        if (i === -1) state.areas.push(a); else state.areas.splice(i, 1);
        var shown = render();
        keepListInView();
        filterEvent('area', a, i === -1, shown);
      });
    });

    function clearAll(source) {
      if (!anySel()) return;
      state.ages = [];
      state.areas = [];
      var shown = render();
      syncBarH();
      filterEvent('clear', source || 'clear_all', false, shown);
    }
    qa('[data-akbp-clear]').forEach(function (b) {
      b.addEventListener('click', function () { clearAll('clear_all'); keepListInView(); });
    });
    removeBestBtn.addEventListener('click', function () {
      var best = removeBestBtn.__best;
      if (!best) return;
      if (best.kind === 'area') state.areas = state.areas.filter(function (x) { return x !== best.id; });
      else state.ages = state.ages.filter(function (x) { return x !== best.id; });
      var shown = render();
      filterEvent(best.kind, best.id, false, shown);
    });

    /* Sticky bar height drives the scroll margin of the cards. */
    function syncBarH() { if (bar) root.style.setProperty('--akbp-bar-h', Math.ceil(bar.getBoundingClientRect().height) + 'px'); }
    syncBarH();
    if (bar) {
      if ('ResizeObserver' in window) new ResizeObserver(syncBarH).observe(bar);
      else window.addEventListener('resize', syncBarH);
    }

    /* In-page links (intro paragraph and picks): reveal the card if a filter hides it. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      if (!id) return;
      var target = document.getElementById(id);
      if (!target || !root.contains(target) || !target.hasAttribute('data-akbp-card')) return;
      if (target.hidden) clearAll('anchor');
      var pick = a.closest('[data-akbp-pick]');
      if (pick) {
        var panel = pick.closest('[role="tabpanel"]');
        var tab = panel ? root.querySelector('[aria-controls="' + panel.id + '"]') : null;
        tag('event', 'ak_blog_pick', {
          item_list_id: LIST_ID,
          ak_tab: tab ? tab.dataset.akbpTab : '',
          item_name: target.dataset.itemName,
          index: Number(target.dataset.index)
        });
      } else if (root.querySelector('.akbp-intro') && root.querySelector('.akbp-intro').contains(a)) {
        tag('event', 'ak_blog_pick', {
          item_list_id: LIST_ID,
          ak_tab: 'paragraph',
          item_name: target.dataset.itemName,
          index: Number(target.dataset.index)
        });
      }
    });

    /* Picks tabs. */
    var tabs = qa('[role="tab"]');
    function selectTab(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) { p.hidden = !on; if (on) p.scrollLeft = 0; }
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (t.getAttribute('aria-selected') === 'true') return;
        selectTab(t, false);
        tag('event', 'ak_blog_tab', { item_list_id: LIST_ID, ak_tab: t.dataset.akbpTab });
      });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); selectTab(n, true); }
      });
    });

    /* Ask us: the WhatsApp message carries the page and the tracking params, like the header button. */
    var ask = q('[data-akbp-ask]');
    if (ask) {
      ask.addEventListener('click', function () {
        try {
          var url = (window.AKZ && window.AKZ.attachTrackingParams)
            ? window.AKZ.attachTrackingParams(new URL(window.location.href))
            : new URL(window.location.href);
          url.hash = '';
          var ref = (typeof window.akRef === 'function') ? window.akRef() : '';
          if (ref) url.searchParams.set('ref', ref);
          var msg = 'I am on page: ' + url.toString() + ' Please suggest places for my kids.';
          ask.href = 'https://wa.me/' + (root.dataset.wa || '919354346834') + '?text=' + encodeURIComponent(msg);
        } catch (err) { /* keep the plain wa.me link */ }
        tag('event', 'ak_blog_ask_us', { item_list_id: LIST_ID, transport_type: 'beacon' });
      });
    }

    /* Birthday cards: Read more opens the clipped text. A text that already fits loses the clip and the button. */
    qa('[data-akbp-txt]').forEach(function (box) {
      var body = box.querySelector('.akbp-exp');
      var btn = box.querySelector('[data-akbp-readmore]');
      if (!body || !btn) return;
      if (body.scrollHeight <= body.clientHeight + 2) {
        box.classList.remove('is-clamped');
        btn.hidden = true;
        return;
      }
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read more';
        if (!open) return;
        var card = box.closest('[data-akbp-card]');
        tag('event', 'ak_blog_details', {
          item_list_id: LIST_ID,
          item_name: card ? card.dataset.itemName : '',
          index: card ? Number(card.dataset.index) : 0
        });
      });
    });

    /* More details opened. */
    qa('[data-akbp-more]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var card = d.closest('[data-akbp-card]');
        tag('event', 'ak_blog_details', {
          item_list_id: LIST_ID,
          item_name: card ? card.dataset.itemName : '',
          index: card ? Number(card.dataset.index) : 0
        });
      });
    });

    /* Impressions and clicks, in the same shape as the Deals rail. */
    function itemFrom(card) {
      return {
        item_id: card.dataset.itemId || undefined,
        item_name: card.dataset.itemName,
        index: Number(card.dataset.index),
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        item_category: card.dataset.kind
      };
    }

    var seen = new Set();
    var timers = new Map();
    var pending = [];
    var flushTimer = null;
    function flush() {
      clearTimeout(flushTimer);
      if (!pending.length) return;
      tag('event', 'view_item_list', {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        ak_filtered: anySel(),
        items: pending
      });
      pending = [];
    }
    function queue(card) {
      var key = card.dataset.index;
      if (seen.has(key)) return;
      seen.add(key);
      if (io) io.unobserve(card);
      pending.push(itemFrom(card));
      clearTimeout(flushTimer);
      flushTimer = setTimeout(flush, 300);
    }
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var key = card.dataset.index;
          if (seen.has(key)) return;
          if (entry.isIntersecting) {
            if (timers.has(key)) return;
            timers.set(key, setTimeout(function () {
              timers.delete(key);
              if (!document.hidden && !card.hidden) queue(card);
            }, 1000));
          } else {
            clearTimeout(timers.get(key));
            timers.delete(key);
          }
        });
      }, { threshold: 0.5 });
      cards.forEach(function (c) { io.observe(c.el); });
    }
    window.addEventListener('pagehide', flush);

    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-akbp-cta]');
      if (!a) return;
      var card = a.closest('[data-akbp-card]');
      if (!card) return;
      var cta = a.dataset.akbpCta;
      clearTimeout(timers.get(card.dataset.index));
      timers.delete(card.dataset.index);
      queue(card);
      flush();
      var item = itemFrom(card);
      var extra = { ak_cta: cta };
      if (cta === 'whatsapp') {
        /* Birthday card: this article page with the tracking params and the ref, then venue=<full venue URL> last.
           venue is appended as plain text, since searchParams would encode its colon and slashes. */
        try {
          var page = new URL(window.location.href);
          page.hash = '';
          if (window.AKZ && window.AKZ.attachTrackingParams) page = window.AKZ.attachTrackingParams(page);
          var ref = (typeof window.akRef === 'function') ? window.akRef() : '';
          if (ref) page.searchParams.set('ref', ref);
          page.searchParams.delete('venue');
          var pageText = page.toString();
          var venue = a.dataset.akbpVenue || '';
          if (venue) pageText += (page.search ? '&' : '?') + 'venue=' + venue;
          var waText = ('I am on page: ' + pageText + ' ' + (a.dataset.akbpWamsg || '')).trim();
          a.href = 'https://wa.me/' + (root.dataset.wa || '919354346834') + '?text=' + encodeURIComponent(waText);
        } catch (err) { /* keep the link built on the server */ }
        try { sessionStorage.setItem('ak_wa', '1'); } catch (err) {}
        tag('event', 'whatsapp_click', {
          ak_source: 'card',
          item_list_id: LIST_ID,
          item_id: item.item_id,
          item_name: item.item_name,
          transport_type: 'beacon'
        });
      }
      if (cta === 'pair') {
        /* The click goes to the paired venue: report that item, and where it came from. */
        extra.ak_from = item.item_name;
        item = {
          item_id: a.dataset.pairId || undefined,
          item_name: a.dataset.pairName,
          index: item.index,
          item_list_id: LIST_ID,
          item_list_name: LIST_NAME,
          item_category: 'pair'
        };
      }
      tag('event', 'select_item', Object.assign({
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        items: [item],
        transport_type: 'beacon'
      }, extra));
    });

    render();
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-akbp]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-akbp]');
    if (el) init(el);
  });
})();
